module.exports = __webpack_public_path__ + "img/02.336aa73c.jpg";